var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('div',[_c('pml-dropzone',{attrs:{"link":("/deals/" + (_vm.deal.id) + "/attachments"),"max-file-size":5,"accepted-files":_vm.acceptedFiles},on:{"upload":_vm.upload}}),_vm._v(" "),_c('hr')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e318b87","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/components/show/attachments/Upload.vue
// module id = null
// module chunks = 